import React, { useState, useEffect } from "react";
import { pb4y } from "../../../../services/apis";
import { Loader } from "semantic-ui-react";
import { datePattern } from "../../../../utils/Utils";
import {
  Container,
  Content,
  SemanticTable,
  ContainerInputSearch,
  Input,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { getToken, isAuthAdmin } from "../../../../services/auth";
import { Box } from "@material-ui/core";

const Trial = () => {
  const [search, setSearch] = useState("");
  const [data, setData] = useState({});
  const [specific, setSpecific] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuth();
    pb4y
      .get("admin/trial")
      .then(res => {
        setData(res.data);
        setLoading(false);
      })
      .catch(err => console.error(err));
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const searchSpecific = () => {
    pb4y
      .get(`admin/specific-nominations?search=${search}`, {
        headers: {
          access_token: `voitto-token ${getToken()}`,
        },
      })
      .then(res => {
        if (res.data.length <= 0) {
          swal(
            "Essa indicação não existe",
            "Faça a busca novamente",
            "warning"
          );
        }
        setSpecific(res.data);
      })
      .catch(err => console.error(err));
  };

  const handleKeyUp = e => {
    if (e.keyCode === 13) {
      searchSpecific();
    }
  };

  return (
    <Box width="100%" paddingLeft="250px">
    <Box width="100%" padding="1rem">
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <main>
              <h1>Tabela de usuários do TRIAL Pocket</h1>
              <ContainerInputSearch>
                <Input
                  type="text"
                  placeholder="Pesquise pelo email do participante"
                  onChange={e => {
                    setSpecific([]);
                    setSearch(e.target.value);
                  }}
                  onKeyUp={e => handleKeyUp(e)}
                />
              </ContainerInputSearch>
              <SemanticTable size="big" celled>
                <SemanticTable.Header>
                  <SemanticTable.Row>
                    <SemanticTable.HeaderCell style={{ width: "40%" }}>
                      Email
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell style={{ width: "20%" }}>
                      Início
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell style={{ width: "20%" }}>
                      Fim
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell style={{ width: "5%" }}>
                      Completo
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell style={{ width: "5%" }}>
                      Valido
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell style={{ width: "5%" }}>
                      Company
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell style={{ width: "5%" }}>
                      Language
                    </SemanticTable.HeaderCell>
                  </SemanticTable.Row>
                </SemanticTable.Header>
                <SemanticTable.Body>
                  {!specific.length
                    ? data
                        .filter(valor =>
                          valor.email
                            .toLowerCase()
                            .includes(search.toLowerCase())
                        )
                        .map((elem, index) => (
                          <SemanticTable.Row key={index}>
                            <SemanticTable.Cell>
                              {elem.email}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {datePattern(elem.date_start)}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {datePattern(elem.date_valid)}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.is_complete === 0 ? "NÃO" : "SIM"}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.is_valid === 0 ? "NÃO" : "SIM"}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.is_company === 0 ? "NÃO" : "SIM"}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.current_lang}
                            </SemanticTable.Cell>
                          </SemanticTable.Row>
                        ))
                    : specific
                        .filter(valor =>
                          valor.email_destino
                            .toLowerCase()
                            .includes(search.toLowerCase())
                        )
                        .map((elem, index) => (
                          <SemanticTable.Row key={index}>
                            <SemanticTable.Cell>
                              {elem.email}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {datePattern(elem.date_start)}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {datePattern(elem.date_valid)}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.is_complete === 0 ? "NÃO" : "SIM"}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.is_valid === 0 ? "NÃO" : "SIM"}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.is_company === 0 ? "NÃO" : "SIM"}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.current_lang}
                            </SemanticTable.Cell>
                          </SemanticTable.Row>
                        ))}
                </SemanticTable.Body>
              </SemanticTable>
            </main>
          </Content>
        )}
        ;
      </Box>
    </Box>
  );
};

export default withRouter(Trial);
